define('Vertex_AddressValidation/js/billing-validation-mixin',[],function() {
    'use strict';

    return function(target) {
        return target.extend({
            addressDetailsVisibilityChanged: function () {
                let validator = this.addressValidator;

                if (typeof validator.message === 'undefined') {
                    return;
                }

                return this._super();
            }
        });
    }
});

